export default __webpack_public_path__ + "static/media/megaphone.2f13b7d9.png";